module.exports = __webpack_public_path__ + "img/title.260b672a.png";